import { BrowserModule } from '@angular/platform-browser';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { StepsModule } from 'primeng/steps';
import { PanelMenuModule } from 'primeng/panelmenu';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { InputTextModule } from 'primeng/inputtext';
import { TabViewModule } from 'primeng/tabview';
import { CalendarModule } from 'primeng/calendar';
import { TableModule } from 'primeng/table';
import { SliderModule } from 'primeng/slider';
import { ToggleButtonModule } from 'primeng/togglebutton';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownModule } from 'primeng/dropdown';
import { DynamicDialogModule } from 'primeng/dynamicdialog';

import { HomeLayoutComponent } from './core/home-layout/home-layout.component';
import { AuthLayoutComponent } from './core/auth-layout/auth-layout.component';

import { HttpClientModule } from '@angular/common/http';

import { environment } from 'src/environments/environment';

// Firebase v7 imports
import { provideFirebaseApp, initializeApp, getApp } from '@angular/fire/app';
import { provideAuth, getAuth, connectAuthEmulator } from '@angular/fire/auth';
import { provideFirestore, getFirestore, connectFirestoreEmulator } from '@angular/fire/firestore';
import { provideStorage, getStorage, connectStorageEmulator } from '@angular/fire/storage';
import { provideFunctions, getFunctions, connectFunctionsEmulator } from '@angular/fire/functions';
import { provideAnalytics, getAnalytics, ScreenTrackingService, UserTrackingService } from '@angular/fire/analytics';

import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputNumberModule } from 'primeng/inputnumber';
import { UsersListComponent } from './users/users-list/users-list.component';


import { CardModule } from 'primeng/card';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DialogService } from 'primeng/dynamicdialog';
import { FileUploadModule} from 'primeng/fileupload';
import { MenuModule } from 'primeng/menu';
import { ConfirmPopupModule } from 'primeng/confirmpopup';
import { ConfirmDialogModule } from 'primeng/confirmdialog'; // Import ConfirmDialogModule
import { ConfirmationService } from 'primeng/api';
import { ToastModule } from 'primeng/toast';
import { MessageService } from 'primeng/api';
import { ProgressBarModule } from 'primeng/progressbar';

// Removed compat imports for Storage and Functions

import { OrderListModule } from 'primeng/orderlist';

import { RadioButtonModule } from 'primeng/radiobutton';
import { ColorPickerModule } from 'primeng/colorpicker';
import { MessagesModule } from 'primeng/messages';
import { MessageModule } from 'primeng/message';

// Removed compat import for Firestore settings
import { SuperAdminLayoutComponent } from './core/super-admin-layout/super-admin-layout.component';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { CookieDialogComponent } from './core/cookie-dialog/cookie-dialog.component';
import { DomesModule } from './domes/domes.module';
import { SharedModule } from './shared/shared.module';
import { DragulaModule } from 'ng2-dragula';
import { DialogModule } from 'primeng/dialog';
import { SplitButtonModule } from 'primeng/splitbutton';
import { ProjectsModule } from './projects/projects.module';

@NgModule({
  declarations: [
    AppComponent,
    HomeLayoutComponent,
    AuthLayoutComponent,
    UsersListComponent,
    SuperAdminLayoutComponent,
    CookieDialogComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    StepsModule,
    PanelMenuModule,
    BrowserAnimationsModule,
    InputTextModule,
    CalendarModule,
    TableModule,
    FormsModule,
    ReactiveFormsModule,
    DropdownModule,
    DynamicDialogModule,
    HttpClientModule,
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideAuth(() => {
      const auth = getAuth();
      if (!environment.production) {
        console.info("RUNNING DEV!")
        connectAuthEmulator(auth, 'http://localhost:9099', { disableWarnings: true });
      }
      else
      {
        console.info("PROD!")
      }
      return auth;
    }),
    provideStorage(() => {
      const storage = getStorage();
      if (!environment.production) {
        connectStorageEmulator(storage, 'localhost', 9199);
      }
      return storage;
    }),
    provideFunctions(() => {
      const functions = getFunctions(getApp(), 'europe-west3');
      if (!environment.production) {
        connectFunctionsEmulator(functions, 'localhost', 5001);
      }
      return functions;
    }),
    provideFirestore(() => {
      const firestore = getFirestore();
      if (!environment.production) {
        connectFirestoreEmulator(firestore, 'localhost', 8080);
      }
      return firestore;
    }),
    provideAnalytics(() => getAnalytics()), // Added Analytics provider
    TabViewModule,
    CardModule,
    TagModule,
    TooltipModule,
    FileUploadModule,
    MenuModule,
    ConfirmPopupModule,
    ConfirmDialogModule, // Add ConfirmDialogModule here
    InputTextareaModule,
    InputNumberModule,
    OrderListModule,
    MessagesModule,
    MessageModule,
    ToastModule,
    DragDropModule,
    SliderModule,
    ColorPickerModule,
    RadioButtonModule,
    ProgressBarModule,
    ToggleButtonModule,
    DomesModule,
    SharedModule,
    DragulaModule.forRoot(),
    DialogModule,
    SplitButtonModule,
    ProjectsModule
  ],
  providers: [
    ScreenTrackingService, 
    UserTrackingService,
    DialogService,
    ConfirmationService,
    MessageService
  ],
  bootstrap: [AppComponent],
  schemas: [ CUSTOM_ELEMENTS_SCHEMA ]
})
export class AppModule { }
